import React from 'react';
import * as queryString from 'query-string';
import PropTypes from 'prop-types';

import WelcomeScreen from '../../../../pages/WelcomePage';
import Login from '../../../../pages/LoginPage/Login';
import Popup from '../../../Popup';
import Join from '../../../../pages/JoinPage/Join';
import { screenToDisplay, screens, areOnboardingScreens } from './utils';

class LoginPopUp extends React.Component {
    constructor(props) {
        super(props);

        this.moveToScreen = this.moveToScreen.bind(this);
        this.moveToNextScreen = this.moveToNextScreen.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.redirectToOnboarding = this.redirectToOnboarding.bind(this);
        this.state = {
            screen: props?.screen || ((!props?.auth?.user && screens.WELCOME) || screenToDisplay(props?.auth, props?.userParamsNeeded)),
        };
    }

    componentDidMount() {
        if (!this.state.screen) {
            if (this.props.onCloseClick) {
                this.props.onCloseClick();
            }
            if (this.props.performAction) {
                this.props.performAction();
            }
            if (this.props.extraFunctionCalls) {
                this.props.extraFunctionCalls();
            }
        } else if (areOnboardingScreens(this.state.screen)) {
            this.redirectToOnboarding();
        }
    }

    componentDidUpdate() {
        if (!this.state.screen) {
            if (this.props.onCloseClick) {
                this.props.onCloseClick();
            }
        } else if (areOnboardingScreens(this.state.screen)) {
            this.redirectToOnboarding();
        }
    }

    redirectToOnboarding() {
        const { location, type } = this.props;

        if (this.props.onCloseClick) {
            this.props.onCloseClick();
        }

        const parsed = queryString.parse(location.search);
        parsed.showPopup = true;
        parsed.type = type;
        const returnUrl = `${location.pathname}${Object.keys(parsed).length > 0 ? `?${queryString.stringify(parsed, { encode: false })}` : ''}`;
        this.props.history.push(`/onboarding?return=${encodeURIComponent(returnUrl)}`);
    }

    moveToScreen(screen, email) {
        if (areOnboardingScreens(screen)) {
            this.redirectToOnboarding();
        } else {
            this.setState({
                screen,
                email,
            });
        }
    }

    moveToNextScreen() {
        const screen = screenToDisplay(this.props.auth, this.props.userParamsNeeded);
        if (screen) {
            this.moveToScreen(screen);
        } else {
            if (this.props.onCloseClick) {
                this.props.onCloseClick();
            }
            if (this.props.performAction) {
                this.props.performAction();
            }
            if (this.props.extraFunctionCalls) {
                this.props.extraFunctionCalls();
            }
        }
    }

    closePopup() {
        if (this.props.onCloseClick) {
            this.props.onCloseClick();
        }
    }

    render() {
        const { titles } = this.props;
        const minHeight = window ? (window.innerHeight > 650 ? 650 : window.innerHeight) : '100%';
        const isWelcomeScreen = this.state.screen === screens.WELCOME;
        const isLoginScreen = this.state.screen === screens.LOGIN;
        const isSignUpScreen = this.state.screen === screens.SIGN_UP;

        return (
            <Popup
                className="popup-md text-left"
                data-testid="modal.login-popup"
                onCloseClick={this.props.onCloseClick}
                config={{
                    noPadding: true,
                    fullScreen: true,
                    topGradient: true,
                    scrollable: !isWelcomeScreen,
                    style: {
                        height: 650,
                        width: 465,
                        maxHeight: '100%',
                        minHeight,
                        background: isWelcomeScreen && 'black',
                    },
                    showCloseIcon: this.props.showCloseIcon ?? true,
                }}
                closeOnClickOutside={this.props.closeOnClickOutside}
            >
                {isWelcomeScreen && (
                    <WelcomeScreen
                        moveToLogin={() => this.moveToScreen(screens.LOGIN)}
                        moveToJoin={() => this.moveToScreen(screens.SIGN_UP)}
                    />
                )}
                {isLoginScreen && (
                    <Login
                        {...this.props}
                        inPopUp
                        forceMobileUi
                        moveToScreen={this.moveToScreen}
                        moveToNextScreen={this.moveToNextScreen}
                        email={this.state.email}
                        {...(titles?.login)}
                    />
                )}
                {isSignUpScreen && (
                    <Join
                        {...this.props}
                        inPopUp
                        forceMobileUi
                        moveToScreen={this.moveToScreen}
                        moveToNextScreen={this.moveToNextScreen}
                        onboardFlow={this.props.onboardFlow}
                        {...(titles?.join)}
                    />
                )}
            </Popup>
        );
    }
}

LoginPopUp.propTypes = {
    auth: PropTypes.shape({
        user: PropTypes.shape({}),
        isAuthenticated: PropTypes.bool,
        token: PropTypes.string,
    }).isRequired,
    userParamsNeeded: PropTypes.bool,
    screen: PropTypes.oneOf(Object.values(screens)).isRequired,
    onCloseClick: PropTypes.func,
    performAction: PropTypes.func,
    extraFunctionCalls: PropTypes.func,
    titles: PropTypes.shape({
        login: PropTypes.shape({}),
        join: PropTypes.shape({}),
    }),
    location: PropTypes.shape({
        search: PropTypes.string.isRequired,
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    type: PropTypes.string,
    history: PropTypes.shape({}).isRequired,
    closeOnClickOutside: PropTypes.bool,
    showCloseIcon: PropTypes.bool,
    onboardFlow: PropTypes.bool,
};

LoginPopUp.defaultProps = {
    userParamsNeeded: false,
    onCloseClick: null,
    performAction: null,
    extraFunctionCalls: null,
    titles: null,
    type: null,
    closeOnClickOutside: false,
    showCloseIcon: true,
    onboardFlow: false,
};

export default LoginPopUp;
